var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"audio-container",on:{"click":_vm.handleClickAudio}},[_c('img',{staticClass:"audio-icon",attrs:{"src":_vm.getAudioStatusIcon(),"alt":"Audio State"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }